import { ELanguage } from '@if/core/types'

/** The string form of a language: what i18next and the user profile's `language` both use. */
export type LanguageCode = 'en' | 'fr'

// Module-level so each language keeps one stable array reference (`useTranslatedOptionEnum` memoizes on it).
const LANGUAGE_ORDER: Record<LanguageCode, ELanguage[]> = {
  en: [ELanguage.English, ELanguage.French],
  fr: [ELanguage.French, ELanguage.English],
}

/** Returns both languages ordered with the user's own language first. */
export const getLanguageOrder = (language: LanguageCode): ELanguage[] => LANGUAGE_ORDER[language]

/** Converts a `'en'` / `'fr'` string to its `ELanguage` counterpart. */
export const toELanguage = (language: LanguageCode): ELanguage =>
  language === 'en' ? ELanguage.English : ELanguage.French

/** Reads a raw profile language into `'en'` / `'fr'` — tolerates `en-CA` like the backend, `null` if unusable. */
export const parseLanguageCode = (value: string | null | undefined): LanguageCode | null => {
  const language = value?.toLowerCase()
  if (language?.startsWith('en')) return 'en'
  if (language?.startsWith('fr')) return 'fr'
  return null
}
